export default "__VITE_PUBLIC_ASSET__fd7449ef__"